<div class="f-checkbox">
  <mat-checkbox [checked]="value" (change)="onCheckboxChange($event)">
    {{ label }}
  </mat-checkbox>
</div>